/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { domain } from './config';
import AmountInput from './components/AmountInput';
import TariffCard from './components/TariffCard';

const Deposit = () => {
    const [loading, setLoading] = useState(true);
    const [isCreatingInvoice, setIsCreatingInvoice] = useState(false);
    const [translations, setTranslations] = useState({});
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [amount, setAmount] = useState("");

    const fetchTranslations = async (language, initData) => {
        const keys = ["history_button", "deposit_label", "deposit_button", "hour", "hours"];
        try {
            const response = await fetch(`${domain}/get-translations`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "authorization": initData,
                },
                body: JSON.stringify({ keys, language }),
            });
            const result = await response.json();
            setTranslations(result);
        } catch (error) {
            console.error(error);
        }
    };

    const calculateTariff = (amount) => {
        if (amount >= 2000) {
            return { price: 8, duration: `1 hour = $8` };  // $2000 = $8/hour
        } else if (amount >= 500) {
            return { price: 9, duration: `1 hour = $9` };  // $500 = $9/hour
        } else {
            return { price: 10, duration: `1 hour = $10` }; // Default tariff
        }
    };

    const tariffs = [
        { price: `> $500`, duration: `$9 ${translations.hour} (+10%)` },
        { price: `> $2000`, duration: `$8 ${translations.hour} (+20%)` },
    ];

    useEffect(() => {
        const initTg = async () => {
            if (window.Telegram && window.Telegram.WebApp) {
                const tgData = window.Telegram.WebApp;
                const initData = tgData.initData;

                try {
                    const response = await fetch(`${domain}/user`, {
                        method: "GET",
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json",
                            "authorization": initData
                        }
                    });

                    if (!response.ok) {
                        tgData.close();
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();
                    await fetchTranslations(data.user.language_code, initData);
                    setLoading(false);
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            } else {
                setTimeout(initTg, 500);
            }
        };

        initTg();
    }, []);

    const handlePay = async () => {
        const numAmount = Number(amount);
        if (!numAmount || numAmount <= 0) {
            setError(translations.deposit_label ? "Please enter amount" : "Введите сумму");
            return;
        }

        setError("");
        setIsCreatingInvoice(true);

        try {
            const tgData = window.Telegram?.WebApp;
            const initData = tgData?.initData || "";

            const response = await fetch(`${domain}/create-invoice`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "authorization": initData,
                },
                body: JSON.stringify({ amount: numAmount }),
            });

            const data = await response.json();

            if (response.ok && data.pay_url) {
                if (window.Telegram?.WebApp?.openLink) {
                    window.Telegram.WebApp.openLink(data.pay_url);
                } else {
                    window.location.href = data.pay_url;
                }
            } else {
                setError(data.detail || "Error creating invoice");
            }
        } catch (err) {
            console.error("Failed to create invoice:", err);
            setError("Failed to create payment invoice");
        } finally {
            setIsCreatingInvoice(false);
        }
    };

    if (loading) {
        return <div className="loading">...</div>;
    }

    const tariff = calculateTariff(Number(amount));

    return (
        <div className="profile-container">
            <button className="create-order-btn" onClick={() => navigate('/history')}>
                {translations.history_button}
            </button>

            <h2>{translations.deposit_label}</h2>
            <AmountInput currency="USD" onChange={setAmount} />
            <br /><br />

            <div className="widget-container">
                <button
                    className="deposit-btn"
                    onClick={handlePay}
                    disabled={isCreatingInvoice || !amount || Number(amount) <= 0}
                >
                    <img
                        src="https://cdn.trybit.com/brand/tb-button-paywith-currency-colour.svg"
                        alt="Pay with Trybit"
                        style={{ height: '28px', width: 'auto', verticalAlign: 'middle' }}
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                    <span>
                        {isCreatingInvoice
                            ? "..."
                            : (translations.deposit_button ? `${translations.deposit_button}` : "Deposit in crypto")}
                    </span>
                </button>

                {error && <p className="deposit-error-msg">{error}</p>}

                <div className="tariff-list">
                    {/* Выводим блок с тарифом, соответствующим введенной сумме */}
                    <TariffCard key={0} price={`Your price $${tariff.price}`} duration={tariff.duration} style={{ backgroundColor: 'yellow', marginLeft: "80px" }} />
                    <br></br>
                    {/* Отображаем все тарифы для справки */}
                    {tariffs.map((tariff, index) => (
                        <TariffCard key={index + 1} price={tariff.price} duration={tariff.duration} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Deposit;
